import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { getToken } from 'utils/token'
import Lightbox from 'react-images'
import styles from './image-gallery.styl'

@connect(({ auth }) => ({
  user: auth.user
}))
class ImageGallery extends Component {
  static propTypes = {
    urls: PropTypes.any,
    user: PropTypes.object,
  }

  state = {
    downloadedImages: [],
    isOpen: false,
    loading: false,
    currentImage: 0,
    error: false
  }

  componentDidMount() {
    const { urls } = this.props

    urls && urls.forEach(url => this.handleDownloadImage(url))
  }

  handleDownloadImage = imageUrl => {
    if (!__CLIENT__) {
      return
    }

    const xhr = new XMLHttpRequest()
    const self = this

    this.setState({
      loading: true
    })

    xhr.open('GET', imageUrl, true)
    xhr.setRequestHeader('Authorization', 'Bearer ' + getToken(this.props.user))
    xhr.responseType = 'blob'

    xhr.onload = function() { // eslint-disable-line
      if (this.status === 200) {
        const reader = new window.FileReader()

        reader.onload = () => {
          self.setState({
            downloadedImages: self.state.downloadedImages.concat({
              src: 'data:image/png;base64,' + reader.result.split(',')[1]
            }),
            loading: false
          })
        }
        reader.readAsDataURL(this.response)
      } else {
        self.setState({
          loading: false,
          error: true
        })
      }
    }
    xhr.send()
  }

  handleOpenLightbox = index => {
    this.setState({
      isOpen: !this.state.isOpen,
      currentImage: index
    })
  }

  handleCloseLightbox = () => {
    this.setState({
      isOpen: false
    })
  }

  handleNext = () => {
    this.setState({
      currentImage: this.state.currentImage + 1
    })
  }

  handlePrev = () => {
    this.setState({
      currentImage: this.state.currentImage - 1
    })
  }

  handleGoToImage = index => {
    this.setState({
      currentImage: index
    })
  }

  render() {
    const { downloadedImages, isOpen, loading, currentImage, error } = this.state

    if (!downloadedImages && !loading) {
      return null
    }

    return (
      <div className={styles.gallery}>
        {loading && <FormattedMessage id='label.loading' defaultMessage='Loading' />}
        {!loading && downloadedImages.map((image, index) => (
          <div key={index} className={styles.thumbWrap}>
            <div
              className={styles.thumbImage}
              style={{ backgroundImage: `url(${image.src})` }}
              onClick={() => this.handleOpenLightbox(index)}
            />
          </div>
        ))}
        {error && <FormattedMessage id='global.something_went_wrong' defaultMessage='Something went wrong' />}
        <Lightbox
          images={downloadedImages}
          currentImage={currentImage}
          isOpen={isOpen}
          onClose={this.handleCloseLightbox}
          onClickNext={this.handleNext}
          onClickPrev={this.handlePrev}
          onClickThumbnail={this.handleGoToImage}
          showThumbnails
        />
      </div>
    )
  }
}

export default ImageGallery
